import * as actionTypes from 'modules/serviceHeaders/actionTypes';
import { createReducer } from 'utils/ReduxUtils';

const initialState = null;

const reset = () => initialState;

const setError = (_, { payload }) => payload;

export default createReducer(initialState, {
  [actionTypes.FETCH_SERVICE_HEADER]: reset,
  [actionTypes.FETCH_SERVICE_HEADER_FAILURE]: setError,
});
